import client from '../client'

export async function changeDetails({
  driverLicenseNumber,
  driverLicenseStateId,
  driverLicenseExpirationDate,
  middleName,
  dateOfBirth,
  houseNumber,
  unitNumber,
  street,
  streetType,
  city,
  stateId,
  mobileNumber,
}) {
  return client(`${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/ChangeDetails`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({
      accountDetails: {
        driverLicenseNumber,
        driverLicenseStateId,
        driverLicenseExpirationDate,
        middleName,
        dateOfBirth,
        houseNumber,
        unitNumber,
        street,
        streetType,
        city,
        stateId,
        mobileNumber,
      },
    }),
  })
}
